import {
  StarRatingSurveyQuestion,
  SurveyResult,
  SurveyResultTypenames,
  ThumbsUpOrDownSurveyQuestion,
} from '@varo/graphql-schema-types';
import { useEffect, useState } from 'react';
import ChatSurvey from 'services/graphql/queries/ChatSurvey';
import { logErrorWithContext } from 'shared/utils/sentry/sentry';
import {
  ErrorSeverity,
  FeatureArea,
  ResponsibleTeam,
} from 'shared/utils/sentry/sentry.constants';
import { useQuery } from 'urql';

type SurveyQuestions = StarRatingSurveyQuestion | ThumbsUpOrDownSurveyQuestion;

const useChatSurvey = (skipSurvey: boolean, chatSessionId: string) => {
  const [questions, setQuestions] = useState<SurveyQuestions[]>();
  const [{ data, fetching }] = useQuery<{
    survey: SurveyResult;
  }>({
    query: ChatSurvey,
    pause: !skipSurvey,
    variables: {
      input: {
        referenceId: chatSessionId,
      },
    },
  });
  useEffect(() => {
    if (data) {
      if (data?.survey.__typename === SurveyResultTypenames.SurveySuccess) {
        setQuestions(data.survey.questions as SurveyQuestions[]);
      }
      if (data?.survey.__typename === SurveyResultTypenames.SurveyError) {
        logErrorWithContext(
          `ChatSurvey error: ${data.survey.title}: ${data.survey.message}`,
          {
            featureArea: FeatureArea.CUSTOMER_SERVICING_SUPPORT,
            responsibleTeam: ResponsibleTeam.CUSTOMER_SUPPORT,
            severity: ErrorSeverity.LOW,
          },
        );
      }
    }
  }, [data]);

  return {
    fetching,
    surveyQuestions: questions,
    setQuestions,
  };
};

export default useChatSurvey;
